import { useCallback, useEffect, useState } from 'react';
import {
  SOUND_PREF_KEY,
  isNotificationSoundEnabled,
  setNotificationSoundEnabled,
} from '@/lib/notification-sound';

/** Per-browser on/off switch for the new-notification sound (default on), kept in sync across tabs. */
export function useNotificationSoundPreference(): [boolean, (enabled: boolean) => void] {
  const [enabled, setEnabled] = useState(isNotificationSoundEnabled);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === SOUND_PREF_KEY) setEnabled(isNotificationSoundEnabled());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const update = useCallback((next: boolean) => {
    setNotificationSoundEnabled(next);
    setEnabled(next);
  }, []);

  return [enabled, update];
}
